const adminDashboardActionsNamespace = "[admin_dashboard]: ";

const adminDashboardActionTypes = {
  SET_ADMIN_DASHBOARD_FILTERS: `${adminDashboardActionsNamespace}SET_ADMIN_DASHBOARD_FILTERS`,
  SET_ADMIN_DASHBOARD_STATISTICS: `${adminDashboardActionsNamespace}SET_ADMIN_DASHBOARD_STATISTICS`,
  SET_ADMIN_DASHBOARD_USER_BENEFITS: `${adminDashboardActionsNamespace}SET_ADMIN_DASHBOARD_USER_BENEFITS`
};

export default adminDashboardActionTypes;
